"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.containerRotate = exports.preloaderRotate = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = require("styled-components");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    0% {\n        stroke-dasharray: 1px, 200px;\n        stroke-dashoffset: 0; \n    } \n    50% {\n        stroke-dasharray: 100px, 200px;\n        stroke-dashoffset: -15px;\n    } \n    100% {\n        stroke-dasharray: 100px, 200px;\n        stroke-dashoffset: -120px;\n    }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    100% {\n        transform: rotate(360deg); \n    } \n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var preloaderRotate = (0, _styledComponents.keyframes)(_templateObject());
exports.preloaderRotate = preloaderRotate;
var containerRotate = (0, _styledComponents.keyframes)(_templateObject2());
exports.containerRotate = containerRotate;